// @flow

import businessErrorMap from './businessErrorMap';

export const GENERAL_ERROR = 'app.error.message.GENERAL';

export const mapError = (message: string) => {
  return businessErrorMap[message] || GENERAL_ERROR;
};
